import type { SlackBlock } from 'common/clients/models/SlackBlock'
import { coreClient } from '@/api/coreclient'

export default {
  async sendError(text: string) {
    const client = await coreClient()
    await client.slack.sendErrorMessage({ text })
  },

  async sendStructuredMessage(blocks: SlackBlock[]): Promise<void> {
    const client = await coreClient()
    await client.slack.sendErrorMessage({ blocks })
  }
}
